var dateFormat = {
	
	/*************************时间格式转换formatDate(new Date(),yyyy-MM-dd)*******************************************/
    padLeftZero: function (str) {
        return ('00' + str).substr(str.length)
    },
    formatDate: function (date, fmt) {
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        let o = {
            'M+': date.getMonth() + 1,
            'd+': date.getDate(),
            'h+': date.getHours(),
            'm+': date.getMinutes(),
            's+': date.getSeconds()
        }
        for (let k in o) {
            if (new RegExp(`(${k})`).test(fmt)) {
                let str = o[k] + ''
                fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : this.padLeftZero(str))
            }
        }
        return fmt
    },

	/*************************文本替换*textReplace('替换的字符串',3,3,'*')******************************************/
	  /* 部分隐藏处理
	     ** str 需要处理的字符串
	     ** frontLen 保留的前几位
	     ** endLen 保留的后几位
	     ** marke 替换的字符串
	     */
	    textReplace(str, frontLen, endLen, marke) {
            if (!str) return '';
	        let len = str.length - frontLen - endLen;
            if (len <= 0) return '******';
	        // let xing = "";
	        // for (let i = 0; i < len; i++) {
	        //     xing += marke;
	        // }
	        return (
	            str.substring(0, frontLen) + "***" + str.substring(str.length - endLen)
	        );
	    }


}


export default dateFormat;